import BaseCallout from './BaseCallout'
import { Typography } from 'components/common'

function IntroToProposalsCallout() {
  return (
    <BaseCallout calloutId={'intro-to-collectives'} type={'Video'}>
      <div className="pb-[5px]">
        <iframe
          width="230"
          src="https://www.youtube-nocookie.com/embed/0yRhtscWmaM"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        <Typography className="pt-[2px] text-[11px] font-light text-right text-gray-500">
          1:30m
        </Typography>
      </div>

      <Typography className="text-base font-normal text-left text-gray-700">
        What are Proposals?
      </Typography>

      <Typography className="text-sm font-light text-left text-gray-600">
        {`Learn how Proposals work from creation, to polling, and execution. Create motions and help your DAO grow.`}
      </Typography>
    </BaseCallout>
  )
}

export default IntroToProposalsCallout
